import isClient from "../../common/isClient";
import getWrappedSrc from './getWrappedSrc';
import { quizImageImageResolution } from '../constants';
/**
 * This function return src for a wrapQuizImageImage.
 *
 * @param src - The image src.
 * @param closestWidth - The image closestWidth width.
 * @param useDevPrefixedUrl - The image use Dev prefixed url.
 * @returns - Return the image url.
 */
const wrapQuizImageImageSrc = (src, closestWidth, useDevPrefixedUrl) => {
    const httpSrc = src.includes('http') || !isClient() ? src : `${window.location.origin}${src}`;
    return getWrappedSrc(httpSrc, quizImageImageResolution[closestWidth], useDevPrefixedUrl);
};
export default wrapQuizImageImageSrc;
//# sourceMappingURL=wrapQuizImageImageSrc.js.map